import URLSearchParams from "@ungap/url-search-params";
import { FormFieldIdValues } from "../renderer/src/types/FormField";
import { SettingsValues } from "@trustarc/form-renderer";

declare global {
  interface Window {
    trustarc: any;
  }
}

// ============ START APPLICATION ============ //

(function () {
  const clientScript = document.createElement("script");
  clientScript.src = "/browser/client.js";
  clientScript.type = "text/javascript";
  clientScript.defer = true;
  document.body.appendChild(clientScript);

  window.trustarc = window.trustarc || {};
  const trustarc = window.trustarc;
  trustarc.upm = [];

  for (
    let methods = ["init", "submit", "destroy"], i = 0;
    i < methods.length;
    i++
  ) {
    const method = methods[i];
    trustarc.upm[method] =
      trustarc.upm[method] ||
      (function (name) {
        return function () {
          const args = Array.prototype.slice.call(arguments);
          trustarc.upm.push([name, args]);
        };
      })(method);
  }

  let container = document.getElementById('container');
  let errorContainer = document.getElementById('error');
  const errorText = document.getElementById('error-text');
  let successContainer = document.getElementById('autoSubmit-success');

  // These are the valid query parameter keys.
  // Other than these, it will be treated as a form field ID default value pair.
  const keys = [
    "brandId",
    "consentFormId",
    "channel",
    "autoSubmit",
    "previewToken",
    "latestPreference",
    "brandPreference",
    "token",
    "locale",
    "confirm",
    "hideFooterButtons",
    "hideSubmitButton",
    "hideResetButton",
    "expiredConsentPreference",
    "previewVersionId",
    "fromLanguageDropdown",
  ];

  const removeFormContainer = () => {
    if (container) {
      container.parentElement.removeChild(container);
      container = null;
    }
  };

  const removeErrorContainer = () => {
    if (errorContainer) {
      errorContainer.parentElement.removeChild(errorContainer);
      errorContainer = null;
    }
  };

  const removeAutoSubmitSuccessContainer = () => {
    if (successContainer) {
      successContainer.parentElement.removeChild(successContainer);
      successContainer = null;
    }
  };

  const showAutoSubmitSuccess = () => {
    removeFormContainer();
    removeErrorContainer();

    if (successContainer) {
      // Display the success message
      successContainer.style.display = "block";
    }
  };

  const showError = (message: string) => {
    removeFormContainer();
    removeAutoSubmitSuccessContainer();

    if (errorText && errorContainer) {
      // Display the error
      errorText.innerText = message;
      errorContainer.style.display = "block";
    }
  };

  try {
    // Get query parameters
    const params = new URLSearchParams(location.search);

    // Read JWT token
    const token = params.get(keys[7]);

    // Read Double Opt-in JWT token
    const confirm = params.get(keys[9]);

    // Read Brand ID
    const brandId = token ? "" : params.get(keys[0]);

    // Read Consent Form ID
    const consentFormId = token ? "" : params.get(keys[1]);

    // Read channel
    const channel = params.get(keys[2]) || "Website";

    // Read autoSubmit
    const autoSubmit =
      params.get(keys[3]) === null ? null : params.get(keys[3]) === "true";

    // Read previewToken
    const previewToken = params.get(keys[4]);

    // Read latestPreference
    const latestPreference = params.get(keys[5]) === "true";

    // Read brandPreference
    const brandPreference = params.get(keys[6]) === "true";

    // Read locale
    const locale = params.get(keys[8]);

    // Read hideFooterButtons
    const hideFooterButtons = token ? "" : params.get(keys[10]) === "true";

    // Read hideSubmitButton
    const hideSubmitButton = token ? "" : params.get(keys[11]) === "true";

    // Read hideResetButton
    const hideResetButton = token ? "" : params.get(keys[12]) === "true";

    // Read default values
    const defaultValues: { [id: string]: any } = {};

    // Read Preview Version ID
    const previewVersionId = params.get(keys[0]);

    // Read fromLanguageDropdown
    const fromLanguageDropdown = params.get(keys[15]) === "true";

    console.log("--- URL Parameters ---");
    for (const [key, value] of params) {
      console.log(`${key}: ${value}`);

      // If neither ['brandId', 'consentFormId', 'channel', 'autoSubmit', 'previewToken']
      if (keys.indexOf(key) === -1) {
        const existingValue = defaultValues[key];
        // If the key has an existing value, then
        // turn the existing value into an array
        // if its not an array yet.
        if (!existingValue) {
          defaultValues[key] = value;
        }
      }
    }
    console.log("------");

    const autoSubmitFn = (
      brandId: string,
      consentFormId: string,
      formFieldIdValues: FormFieldIdValues,
      locale: string,
      token: string,
      formFieldIdFlags: SettingsValues,
      channel: string
    ) => {
      trustarc.upm.submit(
        {
          brandId,
          consentFormId,
          channel,
          formFieldIdValues,
          locale,
          websiteSource: document.referrer || window.location.href,
          token,
          formFieldIdFlags,
        },
        (error: Error) => {
          showError(error.message);
        },
        () => {
          showAutoSubmitSuccess();
        }
      );
    };

    // Render form
    trustarc.upm.init(
      {
        brandId,
        consentFormId,
        channel,
        containerId: container.id,
        defaultValues,
        previewToken,
        latestPreference,
        brandPreference,
        token,
        locale,
        autoSubmit,
        confirm,
        hideFooterButtons,
        hideSubmitButton,
        hideResetButton,
        previewVersionId,
        fromLanguageDropdown,
      },
      (error: Error) => {
        showError(error.message);
      },
      autoSubmitFn
    );
  } catch (error) {
    console.log(error);
    showError("The page has an error.");
  }
})();
